// extracted by mini-css-extract-plugin
export default {"container":"BottomToolbar_container__fhAuZ","toolbarItem":"BottomToolbar_toolbarItem__4YW56"};